import { UAParser } from "ua-parser-js";

export interface DeviceInfo {
  device_os: string;
  device_os_version: string;
  device_family: string;
  is_mobile: string;
}

export async function getDeviceInfo(): Promise<DeviceInfo> {
  const { os, device } = await UAParser(navigator.userAgent).withFeatureCheck();

  const isIPad = device.model === "iPad";

  const base: DeviceInfo = {
    device_os: isIPad ? "iOS" : (os.name ?? ""),
    device_os_version: isIPad ? "" : (os.version ?? ""),
    device_family: [device.vendor, device.model].filter(Boolean).join(" "),
    is_mobile: String(device.type === "mobile" || device.type === "tablet"),
  };

  if (base.device_os.toLowerCase() === "ios" && (navigator.userAgentData as any)?.platform === "Android") {
    base.device_os = "Android";
    base.device_os_version = "";
    base.device_family = "";
  }

  if (base.device_os.toLowerCase() === "android" && navigator.userAgentData) {
    try {
      const hints = await navigator.userAgentData.getHighEntropyValues([
        "platformVersion",
        "model",
      ]);
      if (hints.platformVersion) {
        base.device_os_version = hints.platformVersion;
      }
      if (hints.model) {
        base.device_family = hints.model;
      }
    } catch {
      // Client Hints unavailable — fall back to UA parser values
    }
  }

  return base;
}
